import { render, staticRenderFns } from "./MetaOnlyDisclaimer.vue?vue&type=template&id=125ac622"
import script from "./MetaOnlyDisclaimer.vue?vue&type=script&lang=js"
export * from "./MetaOnlyDisclaimer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports